import AbstractDeviceSetup from "../all/AbstractDeviceSetup";

class Ps4DeviceSetup extends AbstractDeviceSetup {
  constructor() {
    super();
  }
}

export default Ps4DeviceSetup;



// WEBPACK FOOTER //
// ./src/devices/ps4/DeviceSetup.js